import React from "react";
import PhoneInput from "react-phone-input-2";
import PropTypes from "prop-types";
import Error from "./Error";
import "react-phone-input-2/lib/style.css";

const PhoneNumberInput = (props) => {
  const { onChange, value, label, error, name, ...rest } = props;

  return (
    <div className="form-group field-user-cin">
      {error && error[name] && <Error message={error[name]} />}
      <label>
        {label} {rest.required && <span className="text-danger">*</span>}
      </label>
      <PhoneInput
        value={value}
        onChange={onChange}
        name={name}
        country="ug"
        inputStyle={{ width: "100%" }}
        inputProps={{
          maxLength: 16,
        }}
        isValid={(value, country) => {
          if (value.length !== 12) {
            return "Invalid phone number";
          } else {
            return true;
          }
        }}
        countryCodeEditable={false}
        enableSearch
        disableSearchIcon
        // eslint-disable-next-line
        {...rest}
      />
    </div>
  );
};

PhoneNumberInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.shape({}),
};

export default PhoneNumberInput;
